<div class="skill-item" [ngClass]="'skill-item--' + type">
  <div class="skill-item-dot"></div>
  <div class="skill-item-name">{{ skill.i18n?.name || skill.translation }}</div>
</div>
